export enum TrackingTypes {
    gtm = 'gtm',
    interaction = 'interaction',
}
